import styled from 'styled-components';

export const QuoteCardWrapper = styled.div`
  margin-block: 40px;
  background-color: #fff;
  border: 1px solid #7E7E7E;
  box-shadow: rgba(0, 0, 0, 0.16) 0px 2px 8px;
  border-radius: 6px;
  padding: 20px;
  display: flex;

  @media (max-width: 638px) {
    margin-bottom: 20px;
    padding: 14px 14px 24px 14px;
    border: unset;
  }
`;

const QuotationWrapper = styled.div`
  color: #e60000;
  font-size: 100px;

  @media (max-width: 638px) {
    font-size: 70px;
  }
`;

export const LeftQuotationWrapper = styled(QuotationWrapper)`
  margin-top: 14px;
`;

export const RightQuotationWrapper = styled(QuotationWrapper)`
  align-self: end;
  line-height: 0;
  margin-bottom: -6px;
`;

export const CardTextWrapper = styled.div`
  font-size: 28px;
  line-height: 38px;
  text-align: center;
  margin-inline: 30px;

  @media (max-width: 638px) {
    font-size: 19px;
    line-height: 24px;
    margin-inline: -6px;
    margin-block: 16px;
  }
`;
